import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'lp2-cookie-notice',
  templateUrl: './cookie-notice.component.html',
  styleUrls: ['./cookie-notice.component.scss'],
})
export class CookieNoticeComponent {
  @Output() close = new EventEmitter();

  constructor() {}

  emitClose() {
    this.close.emit();
  }
}



// WEBPACK FOOTER //
// ./ts/app/login/cookie-notice/cookie-notice.component.ts